import { Pipe, PipeTransform } from '@angular/core';
import { TagService } from './tag.service';

@Pipe({
  name: 'tagFilter'
})
export class TagFilterPipe implements PipeTransform {

  constructor(private tagService: TagService) { }

  transform(suggestions: any[], tags: any[],  filter: string): any {
    return this.tagService.filterSuggestions(suggestions, tags, filter);
  }
}


// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/tagsComponent/tag-filter.pipe.ts